import { formatDate } from 'src/utils/date-locale';
import { formatDisplayNote } from 'src/utils/formatters';

export const convertResponseItem = (val) => {
  val.optionId = val.trackingId;
  val.updatedDate = formatDate(val.updatedAt, 'dd/MM/yy HH:mm');
  val.remindDate = formatDate(val.remindAt, 'dd/MM/yyyy');
  val.trackingNote = formatDisplayNote(val.note);
  
  delete val.trackingId;
  return val;

  // return {
  //   optionId: val.trackingId,
  //   trackingName: val.trackingName,
  //   statusName: val.statusName,
  //   remindAt: val.remindAt,
  //   trackingStep: val.trackingStep,
  //   id: val.id,
  //   createdDate: formatDate(val.orderTime, 'dd/MM/yyyy'),
  //   remindDate: formatDate(val.remindAt, 'dd/MM/yyyy')
  // };
};

